import { motion, AnimatePresence } from 'framer-motion';

const BASE_WIDTH = 6;
const ACTIVE_WIDTH = 16;

interface Props {
  total: number;
  currentIndex: number;
  onDotClick?: (index: number) => void;
  isDashboard?: boolean;
}

export const PaginationIndicator = ({
  total,
  currentIndex,
  onDotClick,
  isDashboard = false,
}: Props) => {
  const TOTAL_WIDTH = 12 * total + 4;
  const activeColor = isDashboard ? '#8276FC' : '#3D3D3D';

  return (
    <div className="flex w-full items-center justify-center ">
      <div style={{ width: `${TOTAL_WIDTH}px` }} className="flex justify-center gap-[6px]">
        <AnimatePresence mode="popLayout">
          {Array.from({ length: total }).map((_, i) => {
            const isActive = i === currentIndex;
            return (
              <motion.span
                key={i}
                layout
                initial={false}
                animate={{
                  width: isActive ? ACTIVE_WIDTH : BASE_WIDTH,
                  backgroundColor: isActive ? activeColor : '#D1D5DB',
                }}
                transition={{ type: 'spring', stiffness: 400, damping: 40 }}
                className={`h-[6px] cursor-pointer rounded-full `}
                onClick={() => onDotClick?.(i)}
              />
            );
          })}
        </AnimatePresence>
      </div>
    </div>
  );
};
